import React, {useState, Fragment, useEffect} from "react";
import {Col, Container, ListGroup, Row} from "react-bootstrap";



function Linktree(){

    const [linktree, setLinktree] = useState([]);
    const deviantart = process.env.REACT_APP_DEVIANTART;
    const instagram = process.env.REACT_APP_INSTAGRAM;
    const redbubble = process.env.REACT_APP_REDBUBBLE;

    useEffect(() => {
        setLinktree({
            deviantart : deviantart,
            instagram : instagram,
            redbubble : redbubble
        })
    }, [deviantart,instagram,redbubble])

    return (
        <Fragment>
            <section id="signup" className="signup-section">
                <Container key="Social">
                    <Row>
                        <Col></Col>
                        <Col>
                            <ListGroup className="text-center opacity-50 bg-opacity-50 container">
                                <h4 className="mb-4">Linktree</h4>
                                <ListGroup.Item>
                                    <a href={linktree.deviantart} className="list-group-item"  target="_blank"  rel="noopener noreferrer">Deviantart</a>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <a href={linktree.instagram} className="list-group-item"  target="_blank"  rel="noopener noreferrer">Instagram</a>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <a href={linktree.redbubble} className="list-group-item"  target="_blank"  rel="noopener noreferrer">Redbubble shop</a>
                                </ListGroup.Item>
                            </ListGroup>
                        </Col>
                        <Col></Col>
                    </Row>
                </Container>
            </section>
        </Fragment>
    )
}

export default Linktree;